var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import View from "./ui/view";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { CollectHeader } from "./ui/header";
import { themeCore } from "../../assets/themes/theme";
import LocalStorageService from "../../services/localStorage";
import { postCollectionFilesApi } from "../../resources/helper/collection";
import { useStyles } from "./assets/style";
import "./assets/style.css";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
var Collect = function () {
    var _a, _b, _c, _d, _e, _f;
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var state = useLocation().state;
    var usuario = (_a = state === null || state === void 0 ? void 0 : state.usuario) !== null && _a !== void 0 ? _a : false;
    var id = (_b = state === null || state === void 0 ? void 0 : state.id) !== null && _b !== void 0 ? _b : false;
    var fecha = (_c = state === null || state === void 0 ? void 0 : state.fecha) !== null && _c !== void 0 ? _c : false;
    var referencia = (_d = state === null || state === void 0 ? void 0 : state.referencia) !== null && _d !== void 0 ? _d : false;
    var estado = (_e = state === null || state === void 0 ? void 0 : state.estado) !== null && _e !== void 0 ? _e : false;
    var archivos = (_f = state === null || state === void 0 ? void 0 : state.archivos) !== null && _f !== void 0 ? _f : false;
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var classes = useStyles();
    var _g = React.useState(false), loading = _g[0], setLoading = _g[1];
    var _h = React.useState([]), files = _h[0], setFiles = _h[1];
    var _j = React.useState([]), archivosList = _j[0], setArchivosList = _j[1];
    var _k = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _k[0], setSeeToast = _k[1];
    useEffect(function () {
        if (archivos && archivos.length > 0) {
            var tempFiles_1 = [];
            archivos.map(function (item) {
                tempFiles_1.push({
                    name: item,
                    size: "",
                    type: "",
                    title: item,
                    url: item,
                });
            });
            setArchivosList(tempFiles_1);
        }
    }, [archivos]);
    var getEstadoClass = function (estado) {
        switch (estado) {
            case "En Proceso":
                return "estado-en-proceso";
            case "Completado":
                return "estado-completado";
            case "Fallido":
                return "estado-fallido";
            case "Procesando Pagos":
                return "estado-procesando-pagos";
            case "Generando archivo":
                return "estado-generado";
            default:
                return "estado-default";
        }
    };
    var clickBack = function () {
        navigate("/billing");
    };
    // in Collect.tsx
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!id || typeof id !== 'string') {
                        setSeeToast({
                            show: true,
                            type: typeAlert.error,
                            message: 'ID inválido. Imposible cargar archivos.',
                        });
                        return [2 /*return*/];
                    }
                    if (files.length === 0) {
                        setSeeToast({
                            show: true,
                            type: typeAlert.error,
                            message: 'No hay archivos para subir.',
                        });
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    setLoading(true);
                    return [4 /*yield*/, postCollectionFilesApi(id, files)];
                case 2:
                    _a.sent();
                    setSeeToast({
                        show: true,
                        type: typeAlert.success,
                        message: 'Archivos subidos correctamente',
                    });
                    navigate('/billing');
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    console.error(err_1);
                    setSeeToast({
                        show: true,
                        type: typeAlert.error,
                        message: "Error al subir los archivos: ".concat(err_1.message || err_1),
                    });
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(React.Fragment, { children: [_jsx(CollectHeader, { loading: loading, seeToast: seeToast, setSeeToast: setSeeToast }), _jsx(View, { backgroundColorBack: themeCore.colors.buttonPrimary, backgroundColorNext: themeCore.colors.buttonPrimary, title: "Recibir Pago", onClickBack: clickBack, readOnly: true, status: getEstadoClass(estado), estado: estado, details: {
                    title: "Detalle",
                    userLabel: "Usuario",
                    userValue: usuario,
                    creationDateLabel: "Fecha de Creación",
                    creationDateValue: fecha,
                    referenceLabel: "Referencia",
                    referenceValue: referencia || "N/A",
                }, collectionSummary: {
                    title: "Resumen de Cobro",
                    collectionOptionLabel: "Opción de Cobro",
                    collectionOptionValue: "Cobranza mensual normal",
                    batchNumberLabel: "Número de Lote",
                    batchNumberValue: "1",
                    processingDateLabel: "Fecha de Procesamiento",
                    processingDateValue: "31/01/2024",
                    invoiceDateLabel: "Fecha de Facturación",
                    invoiceDateValue: "31/01/2024",
                    parametersLabel: "Parámetros",
                    parameters: ["---", "---", "---"],
                }, billingResults: {
                    title: "Resultados de Facturación",
                    newPoliciesLabel: "Pólizas prima nueva facturada",
                    newPoliciesValue: "10",
                    newPremiumLabel: "Monto Prima Nueva Facturada",
                    newPremiumValue: "Q. 10,000.00",
                    refactoredPremiumLabel: "Rebill",
                    refactoredPremiumValue: "Q. 5,000.00",
                    totalPremiumLabel: "Prima Total",
                    totalPremiumValue: "Q. 15,000.00",
                    cancellationsLabel: "Cancelaciones por morosidad",
                    cancellationsValue: "5",
                    expiredLabel: "Expiradas",
                    expiredValue: "2",
                    invalidBirthDatePoliciesLabel: "Pólizas mala fecha de nacimiento titular",
                    invalidBirthDatePoliciesValue: "1",
                    refactoredPolicyLabel: "Prima refacturadas",
                    refactoredPolicyValue: "100000",
                    totalRefactoredPremiumLabel: "Total prima refacturada",
                    totalRefactoredPremiumValue: "Q. 5,000.00",
                }, uploadedResults: {
                    title: "Resultados de Carga",
                    policiesStatusLabel: "Polizas a Estatus Cancelado",
                    policiesStatusValue: "0",
                    pendingOrSuspenseLabel: "Pendiente o suspenso",
                    pendingOrSuspenseValue: "0",
                    notasDeCobroLabel: "Notas de Cobro pagados",
                    notasDeCobroValue: "0",
                    montoTotalPagarLabel: "Monto Total pagado",
                    montoTotalPagarValue: "Q. 0.00",
                    notasDeCobroRechazadasLabel: "Notas de Cobro Rechazadas",
                    notasDeCobroRechazadasValue: "0",
                    pagosNoLocalizadosLabel: "Pagos no localizados",
                    pagosNoLocalizadosValue: "0",
                    rejectedNotLocalizatedLabel: "Rechazados no localizados",
                    rejectedNotLocalizatedValue: "0",
                    policiesNotLocalizatedLabel: "Pólizas no localizadas",
                    policiesNotLocalizatedValue: "0",
                }, onUploadFiles: function (files) {
                    setFiles(files);
                }, uploadFiles: {
                    title: "Cargar Archivos",
                    uploadPrompt: "*Recuerda que debes cargar la cantidad de archivos que se te solicitan",
                    files: archivosList
                }, onClickGenerate: function () {
                    console.log("Generar");
                }, onClickNext: function () {
                    handleSave();
                }, next: {
                    nextLabel: "Cargar",
                    previousLabel: "Anterior",
                    nextDisabled: false,
                } })] }));
};
export default Collect;
